import { Tag, TagProps } from 'antd';
import { TeamStatuses } from 'store/teams/types';

type Props = {
    status: TeamStatuses;
} & TagProps;

const TeamStatusTag = ({ status }: Props) => {
    switch (status) {
        case TeamStatuses.ACTIVE: {
            return <Tag color="success">Active</Tag>;
        }

        case TeamStatuses.INACTIVE: {
            return <Tag color="error">Deactivated</Tag>;
        }

        case TeamStatuses.DRAFT: {
            return <Tag color="default">Draft</Tag>;
        }

        default: {
            return <Tag color="warning">Unknown Status</Tag>;
        }
    }
};

export default TeamStatusTag;
